<form [formGroup]="form" autocomplete="off" (ngSubmit)="search()">
    <div class="row">
        <rask-input aid="inputNamn" class="col-3" label="{{ 'MOTTAGNINGSPLATS_LIST_NAMN' | translate }}" formControlName="namn"
            [rule]="">
        </rask-input>

        <rask-selector aid="inputMottagningsplatstyp" class="col-3" label="Mottagningsplatstyp"
             [values]="mottagningsplatstyper" formControlName="mottagningsplatstyp" [rule]="">
        </rask-selector>

        <rask-input aid="inputMottagningsplatsnummer" class="col-2" label="{{ 'MOTTAGNINGSPLATS_LIST_MOTTAGNINGSPLATSNUMMER' | translate }}"
            formControlName="mottagningsplatsnummer" [rule]="">
        </rask-input>

        <rask-input aid="inputBeskrivning" class="col-2" label="{{ 'MOTTAGNINGSPLATS_LIST_BESKRIVNING' | translate }}"
            formControlName="beskrivning" [rule]="">
        </rask-input>

        <rask-input aid="inputAnsvarigLogistiker" class="col-2" label="{{ 'MOTTAGNINGSPLATS_LIST_ANSVARIGLOGISTIKER' | translate }}"
            formControlName="ansvarigLogistiker" [rule]="">
        </rask-input>
    </div>
    <div class="row">
        <div class="col">
            <rask-radiobutton-group aid="radioAktiv" label="{{ 'MOTTAGNINGSPLATS_LIST_AKTIV' | translate }}"
                [buttons]="activetypes" formControlName="aktiv" [rule]="">
            </rask-radiobutton-group>
            <rask-radiobutton-group aid="radioAktiv" label="Egen terminal"
                [buttons]="egenTerminalTypes" formControlName="egenTerminal" [rule]="">
            </rask-radiobutton-group>
            <rask-submit-button aid="buttonSok" color="secondary">{{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}
            </rask-submit-button>
        </div>
    </div>
</form>
